import type { NavView } from "../../router/navigationTypes";

export const navViewToPath: Record<NavView, string> = {
  home: "/",
  solver: "/solver",
  results: "/results",
  "solve-history": "/history",
  settings: "/settings",
  "preflop-solutions": "/preflop-solutions",
  "preflop-trace": "/preflop-trace",
  "ai-setup": "/ai-setup",
};

/**
 * Vue 메모리 라우터에 넘길 경로를 결정한다.
 *
 * base 경로 아래의 하위 경로는 그대로 전달한다 — Vue 라우트가 그 경로로 구분되기 때문이다.
 * base 로 접으면 base 라우트가 활성화되어, 하위 경로가 가진 입력(결과 상세의 configHash)이
 * Vue 쪽에 도달하지 않는다.
 *
 * 접두사만 공유하는 형제 경로(`/preflop-trace-2`)는 하위 경로가 아니므로 base 로 접는다 —
 * React Router 가 canonical URL 로 바꾸는 한 프레임 동안 같은 Vue 화면을 유지한다.
 */
export function resolveVueRouterPath(
  navView: NavView,
  routePath: string
): string {
  // Public approval reuses the existing Vue login modal and OAuth return URL.
  if (navView === "home" && routePath.split("?")[0] === "/image-relay/connect")
    return routePath;
  const basePath = navViewToPath[navView];
  if (basePath !== "/" && routePath.startsWith(basePath + "/")) {
    return routePath;
  }

  return basePath;
}
